import { safeStringify } from '@onyx/utils/typescript';

const toDynatraceJSONValue = (value: unknown): JSONValue => {
  if (
    value === null ||
    typeof value === 'string' ||
    typeof value === 'boolean' ||
    typeof value === 'number'
  ) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(toDynatraceJSONValue);
  }
  if (typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .filter(([, v]) => v !== undefined)
        .map(([k, v]) => [k, toDynatraceJSONValue(v)])
    );
  }
  return safeStringify(value) ?? null;
};

export const toDynatraceJSONObject = (
  props: Record<string, unknown>
): JSONObject =>
  Object.fromEntries(
    Object.entries(props).map(([key, value]) => [
      key,
      toDynatraceJSONValue(value),
    ])
  );
